import { render, staticRenderFns } from "./SttP2PEngineEdit.vue?vue&type=template&id=00989a8e&scoped=true"
import script from "./SttP2PEngineEdit.vue?vue&type=script&lang=js"
export * from "./SttP2PEngineEdit.vue?vue&type=script&lang=js"
import style0 from "./SttP2PEngineEdit.vue?vue&type=style&index=0&id=00989a8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00989a8e",
  null
  
)

export default component.exports